import { AxiosRequestConfig } from 'axios';

export default function injectDefaultHeaders(
  conf: AxiosRequestConfig,
): AxiosRequestConfig | Promise<AxiosRequestConfig> {
  return {
    ...conf,
    headers: {
      ...conf.headers,
      'application-key': process.env.REACT_APP_SALES_MANAGER_APPLICATION_KEY,
    },
  };
}
